<template>
    <nav id="menu">
        <ul class="nav-menu pl-0 mb-0">
            <transition-group name="mobile-nav-link">
                <li v-for="(item, index) in items"
                    :key="index"
                    class="nav-menu__item pt-1">
                    <a :href="item.url" class="nav-menu__link" :data-menuanchor="item.slug" @click="clicked()">
                        {{ item.title }}
                    </a>
                </li>
            </transition-group>
        </ul>
    </nav>
</template>

<script>
import Axios from 'axios'

export default {
    name: 'Menu',

    props: {
        onclick: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            items: []
        }
    },

    created() {
        Axios.get(`${this.$VUE_APP_API_URL}/pages?visible=true`).then(res =>{
            this.items = res.data.sort((a, b) => {
                return a.order - b.order
            })
        })
    },

    methods: {
        clicked() {
            this.$emit('update:onclick', false)
        }
    }
}
</script>